__turbopack_context__.v({
  "shimmer": "shimmer-text-module__XwM0Vq__shimmer",
  "shimmer-pulse": "shimmer-text-module__XwM0Vq__shimmer-pulse",
  "shimmer-sweep": "shimmer-text-module__XwM0Vq__shimmer-sweep",
});
